/*@flow*/
import * as t from 'lib/t';

export default t.struct({
  dtstart: t.String,
  dtend: t.String,
  rrule: t.struct({
    freq: t.enums.of('DAILY WEEKLY MONTHLY YEARLY'),
    count: t.maybe(t.subtype(t.Number, v => v > 0)),
    until: t.maybe(t.String),
    byday: t.maybe(t.list(t.enums.of('MO TU WE TH FR SA SU'))),
  }),
});
